import { render, staticRenderFns } from "./warehouseToWarehouse.vue?vue&type=template&id=f4af4450&scoped=true"
import script from "./warehouseToWarehouse.vue?vue&type=script&lang=js"
export * from "./warehouseToWarehouse.vue?vue&type=script&lang=js"
import style0 from "./warehouseToWarehouse.vue?vue&type=style&index=0&id=f4af4450&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4af4450",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4af4450')) {
      api.createRecord('f4af4450', component.options)
    } else {
      api.reload('f4af4450', component.options)
    }
    module.hot.accept("./warehouseToWarehouse.vue?vue&type=template&id=f4af4450&scoped=true", function () {
      api.rerender('f4af4450', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Order/warehouseToWarehouse.vue"
export default component.exports